import { render, staticRenderFns } from "./default-without-header.vue?vue&type=template&id=34627345&"
import script from "./default-without-header.vue?vue&type=script&lang=js&"
export * from "./default-without-header.vue?vue&type=script&lang=js&"
import style0 from "./default-without-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sidebar: require('D:/BitBucket/eezy-work-web/components/Sidebar.vue').default})
